export enum DefaultDateTimeType {
  TONIGHT = "0",
  ONE_DAY = "1",
  THREE_DAY = "2",
  ONE_WEEK = "3",
  TWO_WEEK = "4",
  ONE_MONTH = "5",
}

export type DefaultDateTime = {
  title: string;
  value: DefaultDateTimeType;
};

export const DefaultDateTimes: Array<DefaultDateTime> = [
  {
    title: "تا آخر امروز",
    value: DefaultDateTimeType.TONIGHT,
  },
  {
    title: "یک روز",
    value: DefaultDateTimeType.ONE_DAY,
  },
  {
    title: "سه روز",
    value: DefaultDateTimeType.THREE_DAY,
  },
  {
    title: "هفت روز",
    value: DefaultDateTimeType.ONE_WEEK,
  },
  {
    title: "دو هفته",
    value: DefaultDateTimeType.TWO_WEEK,
  },
  {
    title: "یک ماه",
    value: DefaultDateTimeType.ONE_MONTH,
  },
];
